<script setup>
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import Loading from "../Components/Loading.vue";
import Navbar from "../Components/Navbar.vue";
const page = usePage();
const hideNavBar = computed(() => page.props?.showNavBar === false);
</script>
<template>
    <div>
        <Navbar v-if="!hideNavBar" />
        <Loading />
        <div class="container mx-auto pt-8">
            <slot></slot>
        </div>
    </div>
</template>
